import React from "react";
import AnalyticsHelpIcon from "./AnalyticsHelpIcon";

const stopPanelAction = {
  onClick: (e) => e.stopPropagation(),
  onKeyDown: (e) => e.stopPropagation(),
};

const AnalyticsPanelHead = ({
  title,
  subtitle,
  helpKey,
  extra,
  stopPropagation = true,
  className = "",
}) => {
  if (!title && !subtitle && !extra) return null;

  const actionProps = stopPropagation ? stopPanelAction : {};

  return (
    <div className={`analytics-panel__head ${className}`.trim()}>
      <div>
        {title && (
          <h4>
            {title}
            {helpKey ? <AnalyticsHelpIcon helpKey={helpKey} /> : null}
          </h4>
        )}
        {subtitle && <span>{subtitle}</span>}
      </div>
      {extra ? (
        <div className="analytics-panel__actions" {...actionProps}>
          {extra}
        </div>
      ) : null}
    </div>
  );
};

export const AnalyticsSectionHead = ({ title, helpKey, children }) => (
  <div className="analytics-section-head">
    <h2>
      {title}
      {helpKey ? <AnalyticsHelpIcon helpKey={helpKey} /> : null}
    </h2>
    {children}
  </div>
);

export default AnalyticsPanelHead;
